var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"icon",attrs:{"src":require("@/assets/img/icons/arrow-left-icon.png"),"alt":"arrow-return-colidee"},on:{"click":_vm.returnColidee}})}
var staticRenderFns = []

export { render, staticRenderFns }